export default function isSequential(numbers: number[]) {
  return [...numbers]
    .sort((a, b) => a - b)
    .every((number, index) => {
      if (index === 0) {
        return true; // The first number is always considered sequential
      }
      return number === numbers[index - 1] + 1;
    });
}
